import React from "react";
import { ImagingVisibility } from "../../../app/data/manifest/manifestProfiles";
import { getImagingLabel } from "./imagingUtils";

export interface ImagingStatusBadgeProps {
  visibility: ImagingVisibility;
}

export const ImagingStatusBadge: React.FC<ImagingStatusBadgeProps> = ({ visibility }) => {
  const isComplete = visibility.status === "COMPLETE";

  return (
    <span
      className={`manifest-imaging__badge ${
        isComplete ? "manifest-imaging__badge--complete" : "manifest-imaging__badge--incomplete"
      }`}
    >
      {getImagingLabel(visibility)}
    </span>
  );
};
